import { ChangeEventHandler } from 'react';
import { Select } from 'nhsuk-react-components';
import { campaignTypeToLabel, conditionTargetToLabel } from 'utils/formattingUtils.ts';
import {
  CAMPAIGN_TARGETS,
} from 'schemas/enums/campaigns.ts';
import { CampaignDetails } from 'schemas/CampaignConfig.schema.ts';

interface ISelectCampaignTargetProps {
  formValues: CampaignDetails,
  handleSelectChange: ChangeEventHandler<HTMLSelectElement>,
}

function SelectCampaignTarget({ formValues, handleSelectChange }: ISelectCampaignTargetProps) {
  const options = CAMPAIGN_TARGETS[formValues.Type];
  const campaignTypeLabel = campaignTypeToLabel(formValues.Type).toLowerCase();

  return (
    <Select
      id="campaign-target"
      label={`Choose ${campaignTypeLabel.search(/^a|e|i|o|u/) ? 'a' : 'an'} ${campaignTypeLabel} type`}
      name="Target"
      onChange={handleSelectChange}
      value={formValues.Target}
    >
      {options.map((campaignTarget) => (
        <Select.Option
          value={campaignTarget}
          key={campaignTarget}
        >
          {conditionTargetToLabel(campaignTarget)}
        </Select.Option>
      ))}
    </Select>
  );
}

export default SelectCampaignTarget;
